/**
 * Gets a translation value with fallback to t()
 */

// todo move to nexus
export const getTranslationWithFallback = (
	data: Record<string, Record<string, string> | undefined> | undefined,
	lang: string,
	key: string,
	t: (key: string) => string,
): string => {
	try {
		return data?.[lang]?.[key] || t(key);
	} catch (error) {
		return t(key);
	}
};
